<template>
	<div class="">
		<div v-if="isPhysicalPayer" class="provider-row border-0">
			<div class="title mb-2">
				{{ $auth.user ? 3 : 2 }}. Выбор способа оплаты
			</div>
			<div class="row mb-4">
				<div v-if="isLoadingProvider" class="col-12 my-4 d-flex justify-content-center">
					<b-spinner variant="primary" />
				</div>
				<template v-else>
					<div
						v-for="provider in providers"
						:key="provider.id"
						class="col-12 col-sm-3 provider border-bottom-0"
						@click="setProvider(provider)"
					>
						<div class="btn-provider" :class="{ active: activeProviderName === provider.entity }">
							<b-img
								v-if="provider.css_classes === 'icon-sberbank'"
								width="32"
								src="/svg/qr-code.svg"
								class="mb-2 btn_provider-svg qr"
							/>
							<div v-else :class="`mb-2 btn_provider-svg ${provider.css_classes}`" />
							<div class="d-flex flex-column align-items-center">
								<span class="provider-title">{{ provider.name }}</span>
								<span class="provider-description">{{ provider.description }}</span>
							</div>
						</div>
					</div>
				</template>
			</div>
			<div v-if="isTinkoffProvider">
				<div>
					<b-form-select
						v-model="loanPromoCode"
						:options="loanPromoCodes"
						name="loan_promo_code"
						class="my-3 px-3 col-4 loanPromoCode"
					>
						<template #first>
							<b-form-select-option
								:value="null"
								disabled
							>
								Период и ставка рассрочки
							</b-form-select-option>
						</template>
					</b-form-select>
				</div>
				<div>
					<span v-if="message" class="ml-2 text-danger"> {{ message }}</span>
				</div>
			</div>
		</div>
		<div v-else class="row mb-4">
			<div
				class="col-12 mb-4"
			>
				<div class="title mb-4">
					{{ $auth.user ? 3 : 2 }}.  Оплатить по счету
				</div>
				<FormulateForm
					v-model="values"
					name="checkout"
					remove-label
					@submit="checkoutSubmit"
				>
					<div class="row mb-4">
						<div class="col-12 col-lg-6 mb-5 mb-lg-0">
							<div class="description strong mb-5">
								Данные юридического лица
							</div>
							<FormulateInput
								type="CustomDadataCompany"
								name="name"
								label="Полное наименование организации*"
								:input_options="{placeholder: 'Введите значение'}"
								:style-classes="'user-profile-dadata-input position-relative'"
								:validation="'required'"
								validation-name="company"
								:validation-messages="{
									'required': 'необходимо выбрать компанию из справочника',
								}"
								class="user-profile-field pr-130 checkbox"
								@setCompanyInfo="(value) => fullCompany = value"
							/>
							<FormulateInput
								type="text"
								label="Юридический адрес*"
								name="ur_address"
								placeholder="Введите значение"
								validation-name="Юридический адрес"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
							<FormulateInput
								type="text"
								label="Индекс*"
								name="index"
								placeholder="Введите значение"
								validation-name="Индекс"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
							<FormulateInput
								type="text"
								label="ИНН*"
								name="inn"
								placeholder="Введите значение"
								validation-name="ИНН"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
							<FormulateInput
								v-if="!isIpPayer"
								type="text"
								label="КПП*"
								name="kpp"
								placeholder="Введите значение"
								validation-name="КПП"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
							<FormulateInput
								v-else
								type="text"
								label="КПП*"
								name="kpp"
								placeholder="КПП"
								validation-name="КПП"
							/>
							<!-- <FormulateInput
								type="CustomDadataAddress"
								label="Адрес фактического проживания"
								name="address"
								:set-label="'full_address'"
								:input-options="{placeholder: 'Введите значение'}"
								:request-options="{
									from_bound: { value: 'country' },
									to_bound: { value: 'flat' },
								}"
								:style-classes="'user-profile-dadata-input position-relative'"
								validation-name="address"
								class="user-profile-field"
								@setAddressInfo="(value) => fullUserAddress = value"
							/> -->
						</div>
						<div class="col-12 col-lg-6">
							<div class="description strong mb-5">
								Реквизиты
							</div>
							<FormulateInput
								type="CustomDadataBank"
								label="Название банка*"
								name="bank"
								:input_options="{placeholder: 'Введите значение'}"
								:style-classes="'user-profile-dadata-input position-relative'"
								:validation="'required'"
								validation-name="bank"
								:validation-messages="{
									'required': 'необходимо выбрать банк из справочника',
								}"
								class="user-profile-field"
								@setBankInfo="(value) => fullBank = value"
							/>
							<FormulateInput
								type="text"
								label="БИК*"
								name="bik"
								placeholder="Введите значение"
								validation-name="БИК"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
							<FormulateInput
								type="text"
								label="Корреспондентский счет в ЦБ РФ*"
								name="correspondent_account"
								placeholder="Введите значение"
								validation-name="Корреспондентский счет в ЦБ РФ"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
							<FormulateInput
								type="text"
								label="Расчетный счет*"
								name="checking_account"
								placeholder="Введите значение"
								validation-name="Расчетный счет"
								validation="bail|required|number|between:19,21,length"
								:validation-messages="{
									'required': 'обязательно к заполнению',
									'between': 'счет должен состоять из 20 цифр',
									'number': 'можно использовать только цифры',
								}"
							/>
							<FormulateInput
								type="text"
								label="Город банка*"
								name="bank_city"
								placeholder="Введите значение"
								validation-name="Город банка"
								validation="required"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
						</div>
					</div>
				</FormulateForm>
			</div>
		</div>
		<div class="row mb-4">
			<div class="col-12">
				<FormulateInput
					v-for="(item, index) in agreements"
					ref="agreementInput"
					:key="`agreement-${index}`"
					class="mb-3 small"
					name="publicOfferAgreement"
					type="checkbox"
					validation="required"
					:validation-messages="{
						required: $t('agreementRequired')
					}"
					data-action="publicOfferAgreement"
				>
					<template #label="{ id }">
						<label :for="id" class="ml-2">
							Согласен с <a :href="item" target="_blank"> договором оферты </a>
						</label>
					</template>
				</FormulateInput>
			</div>
		</div>

		<!-- <template v-if="loyalty.loyaltyProfile && $auth.user">
			<charge-points-horizontal
				:value="loyaltyData"
				:price="order.finalPrice"
				:awarded-points="loyalty.awardedPoints"
				:loyalty-profile="loyalty.loyaltyProfile"
				:card-background="loyalty.cardBackground"
				:selected-products="selectedProducts"
				:is-allowed-to-charge="loyalty.isBlockContainsLoyaltyChargeProduct"
				:is-allowed-to-earn="loyalty.isBlockContainsLoyaltyEarnProduct"
				@input="setLoyaltyData"
			/>
		</template> -->
		<div class="row">
			<div class="col-12 order-7 d-flex flex-column justify-content-start" @click="submit">
				<button class="submit btn btn-primary w-100" :disabled="isSubmitDisabled">
					{{ submitText }}
				</button>
				<div v-if="providerError" class="text-danger mt-2">
					Выберите способ оплаты
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ORDER_TYPES, FORM_PAYER_TYPE } from '~/utils/dictionaries';
import ChargePointsHorizontal from '~/components/formulate/loyalty/ChargePointsHorizontal.vue';

const PERSON_SCHEDULE_TYPE = 2;
const IP_SCHEDULE_TYPE = 3;

const ADDITIONAL_CHECKOUT_DATA = {
	bank: 'bank',
	bik: 'bik',
	correspondent_account: 'correspondent_account',
	bank_city: 'bank_city',
};

export default {
	name: 'ThirdStep',
	components: { ChargePointsHorizontal },
	inject: ['person', 'loyalty', 'order'],
	props: {
		block: {
			type: Object,
			default: () => {},
		},
		payerType: {
			type: Number,
			default: FORM_PAYER_TYPE.PHYSICAL,
		},
	},
	data() {
		return {
			isLoadingSubmit: false,
			isLoadingProvider: false,
			providerError: false,
			latestPaymentProvider: null,
			checkoutExists: false,
			activeProvider: null,
			activeProviderName: '',
			providers: [],

			individualScheduleType: [PERSON_SCHEDULE_TYPE, IP_SCHEDULE_TYPE],

			loanPromoCode: null,
			loanPromoCodes: [
				{ value: 'installment_0_0_3_6,0', text: '3 месяца' },
				{ value: 'installment_0_0_4_7,5', text: '4 месяца' },
				{ value: 'installment_0_0_6_10,2', text: '6 месяцев' },
				{ value: 'installment_0_0_10_15,5', text: '10 месяцев' },
				{ value: 'installment_0_0_12_18', text: '12 месяцев' },
				{ value: 'installment_0_0_15_21,5', text: '15 месяцев' },
				{ value: 'installment_0_0_18_24,7', text: '18 месяцев' },
				{ value: 'installment_0_0_24_31', text: '24 месяца' },
				{ value: 'installment_0_0_30_36', text: '30 месяцев' },
				{ value: 'installment_0_0_36_41', text: '36 месяцев' },
			],
			message: null,
			billingOrderReference: null,
			// Uridic/IP fields
			isLoadingCheckout: false,
			values: {
				ur_address: null,
				index: null,
				address: null,
				inn: null,
				kpp: null,
				name: null,
				bank: null,
				bik: null,
				correspondent_account: null,
				checking_account: null,
				bank_city: null,
			},

			fullCompany: null,
			fullBank: null,
			fullUserAddress: null,
			selectedProducts: [],
			loyaltyData: null,
		};
	},
	computed: {
		isTinkoffProvider() {
			return this.activeProviderName === 'TinkoffProvider';
		},
		isSubmitDisabled() {
			return this.isLoadingSubmit || (this.isTinkoffProvider && !this.loanPromoCode);
		},
		invoice() {
			return this.order.data?.invoices[0];
		},
		isPhysicalPayer() {
			return this.payerType === FORM_PAYER_TYPE.PHYSICAL;
		},
		isIpPayer() {
			return this.payerType === FORM_PAYER_TYPE.IP;
		},
		submitText() {
			if (this.isPhysicalPayer) {
				return 'Оплатить';
			}
			if (this.isLoadingCheckout) {
				return 'Скачивается...';
			}
			return 'Сформировать счет';
		},
		agreements() {
			return this.order.unauthAgreements ?? [];
		},
	},
	watch: {
		'order.data': function () {
			if (!this.isPhysicalPayer) this.autocompleteCheckoutForm();
		},
		fullCompany(val) {
			this.values.ur_address = null;
			this.values.index = null;
			this.values.inn = null;
			this.values.kpp = null;
			if (val && val.value) {
				this.values.name = val.value;
				if (val.data) {
					if (val.data.address) {
						this.values.ur_address = val.data.address.value;
						this.values.index = val.data.address.data?.postal_code;
					}
					this.values.inn = val.data.inn;
					this.values.kpp = val.data.kpp;
				}
			}
		},
		fullBank(val) {
			this.values.bik = null;
			this.values.correspondent_account = null;
			this.values.checking_account = null;
			this.values.bank_city = null;
			if (val && val.value) {
				this.values.bank = val.value;
				if (val.data) {
					if (val.data.address) {
						this.values.bank_city = val.data.address.value;
					}
					this.values.bik = val.data.bic;
					this.values.correspondent_account = val.data.correspondent_account;
				}
			} else {
				this.values.bank = null;
			}
		},
		payerType: {
			async handler() {
				await this.getProviders();
			},
		},
	},
	async created() {
		await this.getProviders();
	},
	async mounted() {
		await this.getLatestPaymentProvider();
		await this.getCheckoutExists();

		this.selectedProducts = this.order.data.products;
	},
	methods: {
		async getProviders() {
			this.isLoadingProvider = true;
			this.providerError = false;
			await this.$api.getProviders(this.person?.personData?.order_hash).then((res) => {
				const CHECKOUT_PROVIDER = [86, 16];

				const condition = this.isPhysicalPayer
					? (item) => !CHECKOUT_PROVIDER.includes(item.id)
					: (item) => CHECKOUT_PROVIDER.includes(item.id);
				this.providers = res.data.filter(condition);
			}).finally(() => { this.isLoadingProvider = false; });
		},
		async getLatestPaymentProvider() {
			if (this.order.data.type !== ORDER_TYPES.FREE) {
				const {
					latest_payment_provider: latestPaymentProvider,
				} = await this.$api.getLatestPaymentProvider(this.person?.personData?.order_hash);

				this.latestPaymentProvider = latestPaymentProvider;
			}
		},
		async getCheckoutExists() {
			if (this.order.data.type !== ORDER_TYPES.FREE) {
				const {
					data: checkoutExists,
				} = await this.$api.getCheckoutExists(this.person?.personData?.order_hash);

				this.checkoutExists = checkoutExists;
			}
		},
		async setProvider(provider) {
			this.providerError = false;
			this.activeProvider = provider;
			this.activeProviderName = provider.entity;
		},
		isIndividualScheduleType(scheduleType) {
			return this.individualScheduleType.includes(scheduleType);
		},
		async validateAgreement() {
			// Валидация оферты
			const agreement = this.$refs.agreementInput[0];

			await agreement?.performValidation();
			if (!agreement?.isValid) {
				agreement.formShouldShowErrors = true;
			}

			return agreement?.isValid;
		},
		submit() {
			this.providerError = false;
			if (!this.isPhysicalPayer) {
				this.$formulate.submit('checkout');
			} else if (this.activeProvider) {
				this.pay();
			} else {
				this.providerError = true;
			}
		},
		async pay(isCheckout = false) {
			const isValid = await this.validateAgreement();
			if (!isValid) return;

			this.isLoadingSubmit = true;
			this.message = null;

			if (this.invoice) {
				this.activeInvoice = this.invoice;
				const payload = this.activeProvider.entity === 'TinkoffProvider' ? {
					paymentProvider: this.activeProvider.entity,
					promoCode: this.loanPromoCode,
					is_agree_offer: true,
				} : {
					paymentProvider: this.activeProvider.entity,
					is_agree_offer: true,
				};
				const { data } = await this.$api.payByInvoice(this.invoice, payload);

				if (this.activeProvider.entity !== 'CheckoutProvider' && data.success) {
					window.location = data.payment_url;
				} else if (!data.success) {
					this.message = data.message;
				}

				this.billingOrderReference = data.order.reference;

				this.isLoadingSubmit = false;
				if (!isCheckout) this.$emit('formSuccess');
			}
		},
		async checkoutSubmit(data) {
			const isValid = await this.validateAgreement();
			if (!isValid) return;

			this.isLoadingSubmit = true;
			this.activeProvider = this.providers.find((item) => item.entity === 'CheckoutProvider');
			await this.pay(true);

			data.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			this.$api.createCheckoutForUridic({
				is_agree_offer: true,
				values: { ...data, type_people: 'uridic' },
				reference: this.billingOrderReference,
			}).then((res) => {
				this.checkoutPdf = res.url;

				this.isLoadingCheckout = false;

				window.location = this.checkoutPdf;
				if (!this.isPhysicalPayer) this.$emit('formSuccess');
			}).finally(() => {
				this.isLoadingSubmit = false;
			});
		},
		extractIndex(data) {
			const regex = /^(\d{6}),/;
			const match = data?.match(regex);

			return match ? match[1] : data;
		},
		autocompleteCheckoutForm() {
			const { company } = this.order.data.user;
			const { payer } = this.order.data.user_data;

			Object.entries(ADDITIONAL_CHECKOUT_DATA).forEach(([key, value]) => {
				if (company?.hasOwnProperty(value)) {
					let data = company[value];

					if (key === 'index') {
						data = this.extractIndex(data);
					}

					this.values[key] = data;
				}
			});

			this.values.name = payer?.name;
			this.values.inn = payer?.inn;
			this.values.kpp = payer?.kpp;
			this.values.index = payer?.index;
			this.values.ur_address = payer?.address;
			this.values.address = payer?.address;
		},
		setLoyaltyData(val) {
			this.loyaltyData = val;
		},
	},
};

</script>

<style lang="scss">
@import '~/assets/styles/sk_variables';
@import "~/assets/styles/bootstrap/scss/functions";
@import "~/assets/styles/bootstrap/scss/variables";
@import "~/assets/styles/bootstrap/scss/mixins";

@import "~/assets/styles/components/dev/order.scss";

.loyalty-card {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 1rem 2rem;
	border-radius: 0.5rem;
	font-size: 1.2rem;
	width: fit-content;
	line-height: normal;

	&-title {
		text-transform: uppercase;
		font-weight: bold;
	}
}

.custom-switch {
	padding-left: 2.2rem !important;
}

.provider {
	position: relative;
	border-bottom: 0px solid $border-color !important;
	padding-top: 0;
	padding-bottom: 1rem;
	margin-bottom: 0;
	margin-top: 1rem;

	@include media-breakpoint-up(lg) {
		border-bottom: 0 solid $border-color !important;
	}

	&:first-child {
		&::before {
			display: block;
		}
	}

	&:last-child {
		&::before {
			content: '';
			display: none;
		}
	}
	@include media-breakpoint-down(md) {
		&:nth-child(odd) {
			&::before {
				content: '';
				display: none;
			}
		}

		&:last-child {
			border-bottom: 0 solid $border-color !important;

			&::before {
				content: '';
				display: block;
				position: absolute;
				bottom: 1rem;
				top: 0;
				right: 0;
				border-right: 0px solid $border-color !important;
			}
		}
	}

	&::before {
		content: '';
		display: block;
		position: absolute;
		bottom: 1rem;
		top: 0;
		right: 0;
		border-right: 0px solid $border-color !important;
	}

	.btn-provider {
		background-color: $theme-lightblue;
		&:hover, &.active {
			.btn_provider-svg.qr {
				filter: brightness(0) invert(1);
			}
		}
	}
}
</style>
